export default "__VITE_ASSET__DS1uKZn2__"